import { NotFound } from '@/pages/NotFound';
import { legalMarkdown, renderLegal, type LegalPageName } from '@/lib/legal';
import { useLang, useT } from '@/lib/useLang';
import type { Dict } from '@/i18n';

export const LEGAL_TITLE: Record<LegalPageName, (t: Dict) => string> = {
  privacy: (t) => t.privacy,
  terms: (t) => t.terms,
  'extensions-privacy': (t) => t.extensionsPrivacy,
  'extensions-terms': (t) => t.extensionsTerms,
};

export function LegalPage({ page }: { page: LegalPageName }) {
  const t = useT();
  const lang = useLang();
  const markdown = legalMarkdown(page, lang);

  if (!markdown) return <NotFound />;

  return (
    <section className="nz-page">
      <h1 className="nz-page__title">{LEGAL_TITLE[page](t)}</h1>
      {/* Contenu du dépôt, relu en PR. Voir la note dans `pages/BlogPost.tsx`. */}
      <div className="nz-prose" dangerouslySetInnerHTML={{ __html: renderLegal(markdown) }} />
    </section>
  );
}
